import { render, staticRenderFns } from "./QuestionGroupModal.vue?vue&type=template&id=080185a4"
import script from "../../../scripts/partials/QuestionGroupModal.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/QuestionGroupModal.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports